import React, {  Component } from 'react';

export default class RequestReturnOnlyAccessoriesSelectedOverlayDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showDialog: false
        }
    }
    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
		this.props.handleDialog && this.props.handleDialog("RequestReturnOnlyAccessoriesSelectedOverlayDialog", false);
    }
    componentDidMount() {
		// window.scrollTo(0, 0);
        this.setState({
            showDialog: this.props.showDialog
        });
    }
    render() {
        return (
            <div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="selectionsNotConfirmed">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow">
                    <a className="closeButton" onClick={this.closeDialog.bind(this)}>×</a>
                    <h2 className="title">Action</h2>
					<p><b>It may be less expensive to issue a no charge replacement part or to scrap the product.</b></p>
					<a className="blueButton noButton d-none d-sm-block" onClick={this.closeDialog.bind(this)}>Cancel</a>
					<a className="blueButton yesButton d-none d-sm-block" onClick={this.props.callBackContinue.bind(this)}>Continue</a>
                    <a className="blueButton noButton d-block d-sm-none fs-6" onClick={this.closeDialog.bind(this)}>Cancel</a>
					<a className="blueButton yesButton d-block d-sm-none fs-6" onClick={this.props.callBackContinue.bind(this)}>Continue</a>
				</div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/App/components/dialogs/requestReturnOnlyAccessoriesSelectedOverlayDialog.js